import { FC } from 'react';

import { Step } from './StepTypes';

type Props = {
  currentStep: Step;
  onStepChange: (step: Step) => void;
  disabledSteps?: Step[];
};

const AccreditationOnlineStepper: FC<Props> = ({ currentStep, onStepChange, disabledSteps }) => {
  const steps: { id: Step; title: string }[] = [
    { id: 1, title: 'User Registration' },
    { id: 2, title: 'Accreditation Application' },
    { id: 3, title: 'Submit Application' },
  ];

  return (
    <ol className="flex items-center justify-between mb-8 text-sm">
      {steps.map(step => {
        const isActive = currentStep === step.id;
        const isCompleted = currentStep > step.id;
        const isDisabled = disabledSteps?.includes(step.id) ?? false;

        return (
          <li
            key={step.id}
            className={[
              'flex-1 flex items-center',
              isDisabled ? 'cursor-not-allowed' : 'cursor-pointer',
            ].join(' ')}
            onClick={() => {
              if (isDisabled) return;
              onStepChange(step.id);
            }}
          >
            <div className="flex items-center">
              <div
                className={[
                  'flex h-8 w-8 items-center justify-center rounded-full border text-xs font-semibold',
                  isActive
                    ? 'border-blue-600 bg-blue-600 text-white'
                    : isCompleted
                    ? 'border-green-600 bg-green-50 text-green-700'
                    : 'border-gray-300 bg-white text-gray-600',
                ].join(' ')}
              >
                {step.id}
              </div>
              <div className="ml-3">
                <p
                  className={[
                    'font-medium',
                    isDisabled ? 'text-gray-300' : isActive ? 'text-gray-900' : 'text-gray-600',
                  ].join(' ')}
                >
                  {step.title}
                </p>
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default AccreditationOnlineStepper;
